export default {
	REQUEST_RESET_FAILED: 'REQUEST_RESET_FAILED',
	REQUEST_RESET_ERROR: 'REQUEST_RESET_ERROR',
	REQUEST_RESET_SUCCESS: 'REQUEST_RESET_SUCCESS',
	RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',
	RESET_PASSWORD_UNMATCH: 'RESET_PASSWORD_UNMATCH',
	RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	RESET_PASSWORD_PENDING: 'RESET_PASSWORD_PENDING',
	REQUEST_RESET_PASSWORD_PENDING: 'REQUEST_RESET_PASSWORD_PENDING',
	VERIFY_PENDING: 'VERIFY_PENDING',
	VERIFY_SUCCESS: 'VERIFY_SUCCESS',
	VERIFY_ERROR: 'VERIFY_ERROR',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',
	USER_NOT_REQUESTER: 'USER_NOT_REQUESTER',
	STATS_PENDING: 'STATS_PENDING',
	SOCIAL_LOGIN_SUCCESS: 'SOCIAL_LOGIN_SUCCESS',
	SOCIAL_LOGIN_ERROR: 'SOCIAL_LOGIN_ERROR',
	LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
	LOGOUT_ERROR: 'LOGOUT_ERROR',
	LOGOUT_PENDING: 'LOGOUT_PENDING',
	NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
	NOTIFICATION_ERROR: 'NOTIFICATION_ERROR',
	NOTIFICATION_PENDING: 'NOTIFICATION_PENDING',
	MARK_NOTIFICATION_SUCCESS: 'MARK_NOTIFICATION_SUCCESS',
	MARK_NOTIFICATION_ERROR: 'MARK_NOTIFICATION_ERROR',
	NEW_NOTIFCATION: 'NEW_NOTIFCATION',
	MARK_NOTIFICATION_SUCCESS_ALL: 'MARK_NOTIFICATION_SUCCESS_ALL',
	MARK_NOTIFICATION_ERROR_ALL: 'MARK_NOTIFICATION_ERROR_ALL',
	CHAT_GET_USERS_SUCESS: 'CHAT_GET_USERS_SUCESS',
	CHAT_SEND_SUCESS: 'CHAT_SEND_SUCESS',
	CHAT_SEND_PENDING: 'CHAT_SEND_PENDING',
	CHAT_CHATS_SUCESS: 'CHAT_CHATS_SUCESS',
	CHAT_ACTIVE: 'CHAT_ACTIVE',
	CHAT_NEW_MESSAGE: 'CHAT_NEW_MESSAGE',
	CHAT_SHOW_MODEL: 'CHAT_SHOW_MODEL',
	CHAT_SEARCH: 'CHAT_SEARCH',
	CHAT_ERROR: 'CHAT_ERROR'
};
